<template>
  <div class="mod-user">
    <!-- 搜索栏 -->
    <div class="searchBox">
      <el-form :inline="true" :model="dataForm.paramMap" size="small">
        <el-form-item label="页面类型">
          <el-select class="item-choose" v-model="dataForm.paramMap.no" clearable placeholder="请选择">
            <el-option label="工资条详情页" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="终端类型">
          <el-select class="item-choose" v-model="dataForm.paramMap.sourceType" clearable placeholder="请选择">
            <el-option label="PC端" :value="0"></el-option>
            <el-option label="司机端" :value="1"></el-option>
            <el-option label="管理端" :value="2"></el-option>
            <el-option label="客户端" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select class="item-choose" v-model="dataForm.paramMap.status" clearable placeholder="请选择">
            <el-option label="启用" :value="0"></el-option>
            <el-option label="禁用" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()" type="primary">查询</el-button>
          <el-button @click="() => this.dataForm.paramMap = {}" type="info">重置</el-button>
        </el-form-item>
        <el-form-item style="text-align: right; display: flex; justify-content: flex-end; align-items: center;">
          <div class="operationList">
            <el-button size="small" type="success" @click="newPage('ADD',undefined)">新增页面</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <!-- 产品展示区 -->
    <div class="product-gallery">
      <transition-group name="el-fade-in" tag="div" class="product-grid">
        <div v-for="product in dataList" :key="product.id" class="product-card">
          <!-- 状态 -->
          <div class="card-badge success" v-if="product.status == 0">已启用</div>
          <div class="card-badge error" v-if="product.status == 1">已禁用</div>

          <!-- 终端类型 -->
          <div class="card-badge" style="background-color: #4a6bdf;left: auto;right: 10px;" v-if="product.sourceType == 0">PC端</div>
          <div class="card-badge" style="background-color: #00a854;left: auto;right: 10px;"  v-if="product.sourceType == 1">司机端</div>
          <div class="card-badge" style="background-color: #f56a00;left: auto;right: 10px;"  v-if="product.sourceType == 2">管理端</div>
          <div class="card-badge" style="background-color: #884dff;left: auto;right: 10px;"  v-if="product.sourceType == 3">客户端</div>

          <!-- 封面图 -->
          <div class="product-image-background" :style="{ backgroundImage: `url(${ domain + product.surfaceDrawingUrls})` }"></div>

          <!-- 信息 -->
          <div class="product-info-overlay">
            <h3 class="product-title">{{ product.title }}</h3>
            <p class="product-desc">{{ product.remark }}</p>
            <div class="price-section">
              <span class="current-price" v-if="product.no == 1">工资条详情页</span>
              <!--<span class="original-price">wwww</span>-->
            </div>
            <div class="product-actions">
              <el-button type="primary" size="small" plain class="action-btn" @click="newPage('VIEW',product)">查看</el-button>
              <el-button type="info" size="small" plain class="action-btn" @click="newPage('EDIT',product)">编辑</el-button>
              <el-button :type="product.status == 0 ? 'danger' : 'success'" size="small" plain class="action-btn" @click="statusPage(product)">{{ product.status == 0 ? '禁用' : '启用' }}</el-button>
              <el-button type="danger" size="small" plain class="action-btn" @click="deletePage(product)">删除</el-button>
            </div>
          </div>
        </div>
      </transition-group>
    </div>

    <!-- 分页器 -->
    <el-pagination @size-change="sizeChangeHandle"
                   @current-change="currentChangeHandle"
                   :current-page="dataForm.page"
                   :page-sizes="[20, 50, 100]"
                   :page-size="dataForm.size"
                   :total="dataForm.total"
                   layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>

    <!-- 配置窗 -->
    <pageDetail ref="pageDetailRef" @sizeChangeHandle="sizeChangeHandle" />
  </div>
</template>

<script>
import pageDetail from "@/views/modules/page/detail/page-detail";

export default {
  data() {
    return {
      // 域名
      domain: '',

      // 搜索信息
      dataForm: {
        page: 1,
        size: 20,
        total: 0,
        paramMap: {}
      },

      // 列表
      dataList: []
    }
  },
  components: { pageDetail },
  activated() {
    this.$http({
      url: this.$http.adornUrl('/sys/appConfig/get'),
      method: 'get',
      params: this.$http.adornParams({ type: 2 })
    }).then(({ data }) => {
      this.domain = JSON.parse(data.configValue).spaceDomain
    })

    let params = this.$route.params
    if (params && params.key) {
      this.dataForm.paramMap.no = params.no
      this.dataForm.paramMap.sourceType = params.sourceType
    }

    this.getDataList()
  },
  computed: {},
  methods: {
    /**
     * 每页大小
     * @param val 当前选中页大小
     */
    sizeChangeHandle(val) {
      this.dataForm.size = val
      this.dataForm.page = 1
      this.getDataList()
    },

    /**
     * 当前页
     * @param val 当前选中的页数
     */
    currentChangeHandle(val) {
      this.dataForm.page = val
      this.getDataList()
    },

    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      // 执行
      this.$http({
        url: this.$http.adornUrl('/pageConfig/page'),
        method: 'post',
        data: this.dataForm
      }).then(({ data }) => {
        this.dataList = data.records
        this.dataForm.total = data.total
      }).finally(() => {
        this.dataListLoading = false
      })
    },

    // 操作页面
    newPage(type,row) {
      this.$refs.pageDetailRef.init(type,row)
    },
    deletePage(row) {
      this.$confirm(`确定删除${row.title}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/pageConfig/' + row.id),
          method: 'delete',
        }).then(({ data }) => {
          if (data) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      }).catch(() => {})
    },
    statusPage(row) {
      this.$confirm(`是否${row.status == 0 ? '禁用' : '启用'}${row.title}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/pageConfig/status'),
          method: 'get',
          params: {id: row.id,status: row.status == 0 ? 1 : 0}
        }).then(({ data }) => {
          if (data) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.product-gallery {
  height: 72vh;
  overflow-y: auto;
  margin: 20px 0;
  .product-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
    gap: 10px;
  }
  .product-card {
    position: relative;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    cursor: pointer;
    min-height: 350px; // 设置一个最小高度
    display: flex;
    flex-direction: column;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 15px 30px rgba(0, 0, 0, 0.12);
    }

    .card-badge {
      position: absolute;
      top: 10px;
      left: 10px;
      color: white;
      padding: 3px 8px;
      border-radius: 10px;
      font-size: 12px;
      z-index: 2;

      &.success {
        background-color: #52c41a;
      }
      &.error {
        background-color: #ff4d4f;
      }
    }

    .product-image-background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      z-index: 1;

      // 添加一个半透明的黑色覆盖层，提高文字可读性
      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(to bottom, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.7) 100%);
      }
    }

    .product-info-overlay {
      position: relative;
      z-index: 2;
      padding: 20px;
      color: white;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;

      .product-title {
        margin: 0 0 8px;
        font-size: 18px;
        font-weight: 600;
        text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
      }

      .product-desc {
        margin: 0 0 15px;
        font-size: 14px;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .price-section {
        margin: 10px 0 15px;

        .current-price {
          font-size: 10px;
          font-weight: bold;
          color: #fff;
        }

        .original-price {
          font-size: 16px;
          color: rgba(255, 255, 255, 0.7);
          text-decoration: line-through;
          margin-left: 8px;
        }
      }

      .product-actions {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;

        .action-btn {
          flex: 1;
          padding: 8px 5px;
          border-radius: 4px;
          font-size: 12px;
          transition: all 0.3s;

          &:first-child {
            //margin-right: 8px;
          }

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
          }
        }
      }
    }
  }
}
// 响应式调整
@media (max-width: 768px) {
  .product-gallery .product-grid {
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  }

  .product-card {
    min-height: 300px !important;
  }
}
</style>
